import React from 'react';
import { Grid } from '@mui/material';

export const LoggedOutActionsLayout: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Grid
    container
    justifyContent="center"
    alignItems="center"
    maxWidth="sm"
    margin="auto"
    width="100%"
  >
    <Grid
      size={{
        xs: 12,
        md: 8,
      }}
      offset={{
        xs: 0,
        md: 2,
      }}
    >
      {children}
    </Grid>
  </Grid>
);
